import type { MarkerGroupProps } from "./marker-group.type";

import { MARKER_CIRCLE_SCALE, MarkerCircle } from "../marker-circle";

const MarkerGroup = ({ count, color }: MarkerGroupProps) => {
  return (
    <MarkerCircle
      content={count}
      color={color}
      scale={MARKER_CIRCLE_SCALE.XL}
    />
  );
};

export default MarkerGroup;
